import { readStates } from '@/constants/lifecycle';

const cohortProfileActions = {
  FETCH_CLAUSE_COUNTS: 'FETCH_CLAUSE_COUNTS',
  SHOW_CLAUSE_COUNTS: 'SHOW_CLAUSE_COUNTS',
  SHOW_CLAUSE_COUNTS_ERROR: 'SHOW_CLAUSE_COUNTS_ERROR',
  SHOW_CLAUSE_COUNTS_CANCELLED: 'SHOW_CLAUSE_COUNTS_CANCELLED',
  FETCH_CLAUSES_COUNTS: 'FETCH_CLAUSES_COUNTS',
  SHOW_CLAUSES_COUNTS: 'SHOW_CLAUSES_COUNTS',
  SHOW_CLAUSES_COUNTS_ERROR: 'SHOW_CLAUSES_COUNTS_ERROR',
  SHOW_CLAUSES_COUNTS_CANCELLED: 'SHOW_CLAUSES_COUNTS_CANCELLED',
  TOGGLE_CLAUSE_COUNTS: 'TOGGLE_CLAUSE_COUNTS',
  TOGGLE_CLAUSES_COUNTS: 'TOGGLE_CLAUSES_COUNTS',
};

export const cohortProfileStates = {
  ...readStates,
};

export default cohortProfileActions;
